import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
const finalIncludes = ["Instant digital access", "Six premium educational volumes", "Five professional bonuses", "Printable review tools", "Seven-day money-back guarantee"];
export function FinalCtaSection() {
  return <section className="bg-navy px-5 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-161" data-mp="2rj4mhotp9oca">
      <div className="mx-auto max-w-3xl text-center" data-id="element-162" data-mp="2rh1ooimb2qx0">
        <h2 id="final-title" className="font-serif text-[32px] leading-[1.12] sm:text-5xl font-bold text-white text-balance" data-id="element-163" data-mp="2mj05lxovqrlj">
          Ready to Study Otoplasty With a More Organized System?
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-164" data-mp="2wb5u2xfxaqvz">
          You don't necessarily need another collection of disconnected educational resources. You need a structured way to review the
          concepts, organize your questions, study cases, and document what you learn.
        </p>
        <p className="mt-3 text-lg font-semibold text-white" data-id="element-165" data-mp="221w4truv8kdj">That's why I created Otoplasty Clinical Pathway System™.</p>

        <img src={images.mockup} alt="All 6 volumes and 5 bonuses" className="mx-auto mt-8 w-full max-w-xl rounded-3xl bg-white" loading="lazy" data-id="element-166" data-mp="262g0ss3pdhy3" />

        <p className="mt-8 text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-167" data-mp="2g0vi63cxhcue">Get all 6 volumes + 5 bonuses today</p>
        <p className="mt-1 font-serif text-7xl sm:text-8xl font-extrabold text-white" data-id="element-168" data-mp="2kynk7q7aefcb">
          $27<span className="ml-2 align-top font-sans text-2xl font-bold text-white/70" data-id="element-169" data-mp="2ozz37cvno2bj">USD</span>
        </p>

        <ul className="mx-auto mt-6 inline-flex flex-col gap-2.5 text-left" data-id="element-170" data-mp="2tt1ybpg2zjtu">
          {finalIncludes.map(item => <li key={item} className="flex gap-3 text-base text-white" data-id="element-171" data-mp="2yq237x172gjd">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-172" data-mp="33qzoiihi3qp3" />
              <span data-id="element-173" data-mp="38q2ohoimj6q7">{item}</span>
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-174" data-mp="2j0cfz5ttkfgo">
          <CtaButton label="Yes, I want Otoplasty Clinical Pathway System™" pulse data-id="element-175" data-mp="2j1nlba2wxv9w" />
          <p className="mt-3 text-sm text-white/70" data-id="element-176" data-mp="2e2u5vc42fu73">One-time payment · No recurring fees · 7-day guarantee</p>
        </div>
      </div>
    </section>;
}